import * as yup from 'yup';

import validatePhone from './validatePhone';
import { TRANSLATIONS as text } from '../../translations';

const { addressForm } = text;
const { formErrors, formValidations } = addressForm;
const allowedChars = RegExp(/^([a-zA-Z -]+)$/);

const validateName = {
  homeAddress: formValidations.charsNotAllowed,
  collectFrom: formValidations.nameInvalidChars,
};

const validateUser = (name = 'homeAddress') => {
  return yup
    .object()
    .shape({
      firstName: yup
        .string()
        .trim()
        .required(formErrors.firstName)
        .matches(allowedChars, validateName[name]),

      lastName: yup
        .string()
        .trim()
        .required(formErrors.lastName)
        .matches(allowedChars, validateName[name]),
    })
    .concat(validatePhone);
};

export default validateUser;
